/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 6/20/19
 * Time: 10:34 AM
 */
import React, {Component} from 'react';
import {Card} from 'semantic-ui-react'
import {Row, Col} from "reactstrap";
import axiosTags from "../../../axios/axios_tag";
import * as common from "../../../const/Common/CommonFunc";
import Cookies from "js-cookie";
import PlaceHolder from "../../../components/PlaceHolder/PlaceHolder";
import apiConfig from "../../../axios/axios_api_services";

let date = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate();

class App extends Component {
  state = {
    spin:true,
    dashboards: []
  };

  getAllDashboards = () => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axiosTags.get(apiConfig.SUPER_DASHBOARD,{headers: headers})
      .then(response => {
        if (response.data.success) {
            this.setState({
              dashboards: response.data.dashboardCards,
              spin: false
            })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllDashboards();
        }
      });
  };

  componentDidMount(){
    this.getAllDashboards();
  }

  render() {
    const {dashboards} = this.state;
    return (
      <Row>
        {
          dashboards.length !== 0 ?
            dashboards.map((element, index) => (
              <Col key={index}>
                <Card
                  fluid
                  color={"orange"}
                  link
                  header={element.name}
                  meta={"Number Of All "+element.name}
                  description={element.count}
                  extra={date}

                />
              </Col>
            ))
            : <PlaceHolder data={[1,2]}/>
        }
      </Row>
    );
  }
}

export default App;
